import React, { Component } from "react";
import { withRouter } from "../../hoc/withRouter";
import { config } from "../../config/GeneralConfig";
import { Form, Select } from "antd";

const { Option } = Select;

class SelectStatusNotice extends Component {
  render() {
    const { opt_notice_uploaded } = config;
    return (
      <Form.Item label="Notice Uploaded">
        <Select style={{ fontSize: "85%" }} placeholder="Select Data" defaultValue={this.props.value} onChange={this.props.onChangeValue}>
          {Object.keys(opt_notice_uploaded).map((s) => {
            return (
              <Option key={s} value={s}>
                {opt_notice_uploaded[s]}
              </Option>
            );
          })}
        </Select>
      </Form.Item>
    );
  }
}

export default withRouter(SelectStatusNotice);
